import { Component, inject, OnInit } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

import { HeaderComponent } from '../../layouts/header/header.component';
import { OverviewStore } from './overview.store';
import { OverviewSidemenuComponent } from './overview-sidemenu/overview-sidemenu.component';
import { OverviewTableComponent } from './overview-table/overview-table.component';

@Component({
  imports: [
    OverviewSidemenuComponent,
    OverviewTableComponent,
    HeaderComponent,
    MatExpansionModule,
  ],
  selector: 'norupe-overview',
  styles: ``,
  templateUrl: './overview.component.html',
})
export class OverviewComponent implements OnInit {
  private overviewStore = inject(OverviewStore);
  ngOnInit() {
    this.overviewStore.loadOverview({});
  }
}
